import { useQueryClient } from "@tanstack/react-query";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

import { useFavoriteQueries } from "../../../../hooks";
import { NotificationsLevel } from "../../../../lib/enums";
import { show } from "../../../../notifications/notifications";
import { advancedSearchKeys } from "../../../samples/queryKeys";
import { IDeleteFavoriteModalProps } from "./@types/DeleteFavoriteModal";

const DeleteFavouriteModal = ({
  id,
  name,
  onClose
}: IDeleteFavoriteModalProps) => {
  const queryClient = useQueryClient();
  const { removeAsync } = useFavoriteQueries();

  const handleSubmit = () => {
    removeAsync(id)
      .then(() => {
        show({
          level: NotificationsLevel.SUCCESS,
          message: "Favorite query successfully deleted."
        });
        queryClient.invalidateQueries({
          queryKey: advancedSearchKeys.fetchUserData
        });
        onClose();
      })
      .catch(() => {
        show({
          level: NotificationsLevel.ERROR,
          message:
            "Oops! Error while deleting favorite query. Please try again."
        });
        onClose();
      });
  };

  return (
    <Modal show size="sm" onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Remove Favorite</Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={e => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <Modal.Body>
          Are you sure you want to delete favorite query: &quot;
          {name}&quot;?
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" variant="prompt-secondary">
            Remove
          </Button>
          <Button type="button" variant="prompt-primary" onClick={onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DeleteFavouriteModal;
